import { render, staticRenderFns } from "./SupplierTable.vue?vue&type=template&id=4170c61d&scoped=true&"
import script from "./SupplierTable.vue?vue&type=script&lang=js&"
export * from "./SupplierTable.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTable.vue?vue&type=style&index=0&id=4170c61d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170c61d",
  null
  
)

export default component.exports